import {
  getUserListEndpoint,
  getDisputeUsersEndpoint,
  createShareFilterEndpoint,
  getShareFilterEndpoint,
  triggerShareFilterEmailEndpoint,
  getFiltersEndPoint,
  createFilterPreferenceEndPoint,
  updatedFilterPreferenceEndPoint,
  product_id,
  getUserListsEndpoint,
  getCountryDetailsEndPoint,
  getCarrierCodeDetailsEndPoint,
} from "@/config/apiEndPoints";

// Constants
import { APIGEE_CLIENT_KEY_ACCOUNT } from "@/config/constant";
import { APIGEE_CLIENT_KEY_DATA } from "../config/constant";

const getUserList = (params, idToken) => {
  return {
    method: "get",
    url: getUserListEndpoint,
    params: params,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const getUserLists = (keyword, idToken, msalToken) => {
  return {
    method: "get",
    url: getUserListsEndpoint,
    params: {
      userName: keyword,
      apmId: keyword,
      conditionType: "OR",
    },
    headers: {
      apiAuthorization: msalToken,
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const createShareFilter = (appliedFilters, idToken, msalToken) => {
  return {
    method: "post",
    url: createShareFilterEndpoint(product_id),
    headers: {
      apiAuthorization: msalToken,
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
    data: {
      filter_json: JSON.stringify(appliedFilters),
    },
  };
};

const getUserListFromAzureAdByEmployeeId = (keyword, groupId, idToken) => ({
  method: "get",
  url: `${getDisputeUsersEndpoint}/${groupId}/members`,
  params: {
    filter: keyword,
    pageSize: 30,
  },
  headers: {
    Authorization: idToken,
    "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
  },
});

const getShareFilter = (shareFilterId, idToken, msalToken) => {
  return {
    method: "get",
    url: getShareFilterEndpoint(product_id, shareFilterId),
    headers: {
      apiAuthorization: msalToken,
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const triggerEmailForShareFilter = (
  shareFilterId,
  emailRecipients,
  sharedBy,
  idToken,
  msalToken
) => {
  return {
    method: "post",
    url: triggerShareFilterEmailEndpoint(product_id, shareFilterId),
    headers: {
      apiAuthorization: msalToken,
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
    data: {
      filter_id: shareFilterId,
      shared_by: sharedBy,
      email_recipients: emailRecipients,
    },
  };
};

const getFilterPreference = async (idToken, msalToken) => {
  return {
    method: "get",
    url: getFiltersEndPoint,
    headers: {
      apiAuthorization: msalToken,
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const getCountryDetails = async (idToken) => {
  return {
    method: "get",
    url: getCountryDetailsEndPoint,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};

const getCarrierCodeDetails = async (idToken) => {
  return {
    method: "get",
    url: getCarrierCodeDetailsEndPoint,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DATA,
    },
  };
};

const deleteFilterPreference = async (idToken, msalToken, filterTitle) => {
  return {
    method: "delete",
    url: `${getFiltersEndPoint}/${filterTitle}`,
    headers: {
      apiAuthorization: msalToken,
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const saveFilterPreference = async (
  requestPayload,
  isUpdate,
  idToken,
  msalToken
) => {
  return {
    method: isUpdate ? "put" : "post",
    url: isUpdate
      ? updatedFilterPreferenceEndPoint
      : createFilterPreferenceEndPoint,
    data: requestPayload,
    headers: {
      apiAuthorization: msalToken,
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

export default {
  getUserList,
  getUserListFromAzureAdByEmployeeId,
  createShareFilter,
  getShareFilter,
  triggerEmailForShareFilter,
  getFilterPreference,
  deleteFilterPreference,
  saveFilterPreference,
  getUserLists,
  getCountryDetails,
  getCarrierCodeDetails,
};
